export class MainUiGrid
{
	constructor(options = {name: "MainUiGrid"}) {
		this.name = options.name;

        this.init();
	}

    init() {
        this.learnedLessons();
        this.checklistsAndPrescriptions();
        this.fireSafetyBriefing();
        this.anketologDangerMap();
    }

    anketologDangerMap() {
        let LIST_ID = BX.message("LIST_ID_ANKETOLOG_DANGER_MAP");

        this.addRowsSubMenuItem(LIST_ID, {
            "ID": "printForm",
            "text": "Скачать печатную форму",
            "href": `/include/anketologDangerMap.php?iListId=#iListId#&iElId=#iItemId#`
        });
    }

    fireSafetyBriefing() {
        let LIST_ID = BX.message("LIST_ID_FIRE_SAFETY_BRIEFING");

        this.addRowsSubMenuItem(LIST_ID, {
            "ID": "printForm",
            "text": "Скачать печатную форму",
            "href": `/include/downloadListItemPdf.php?iListId=#iListId#&iElId=#iItemId#`
        });


        for (let sEvent of ["Grid::ready", "Grid::updated"]) {
            BX.addCustomEvent(sEvent, function (obMainGrid) {
                if (obMainGrid.containerId != `lists_list_elements_${LIST_ID}`) {
                    return true;
                }

                let obActPanel = obMainGrid.actionPanel;
                let obControlItem = obActPanel.createButton({
                    TYPE: obActPanel.types.BUTTON,
                    CLASS: "apply",
                    ID:    "multiple_bizproc_execution",
                    TITLE: "Запустить бизнес процессы",
                    NAME:  "Запустить бизнес процессы",
                    TEXT:  "Запустить бизнес процессы",
                    ONCHANGE: [
                        {
                            ACTION: obActPanel.actions.CALLBACK,
                            DATA: [
                                {
                                    JS: `BX.Webrover.obTemplate.getMainUiGrid().executeFireSafetyBriefingBizproc("lists_list_elements_${LIST_ID}");`
                                }
                            ]
                        }
                    ]
                }, "control_");
                obMainGrid.actionPanel.getControls()[0].parentNode.append(obControlItem)
            });
        }
    }

    executeFireSafetyBriefingBizproc(sGridId) {
       let oGrid = BX.Main.gridManager.getById(sGridId).instance;
       let aItemIds = oGrid.getRows().getSelectedIds();
       let requests = {
          aItemIds: aItemIds,
          *[Symbol.iterator]() {
                for (let i = 0; i < this.aItemIds.length; i++) {
                   yield new Promise(resolve => {
                      BX.ajax({
                            method: "POST",
                            dataType: "json",
                            url: "/api/v1/bizproc/",
                            data: JSON.stringify({
                               method: "startFireSafetyBriefingWorkFlow",
                               data: {
                                  iDocumentId: this.aItemIds[i]
                               }
                            }),
                            onsuccess: resolve(`Done for ${this.aItemIds[i]}`)
                      });
                   });
                }
          }
       };

       Promise.all([...requests]).then(result => {
          alert("Бизнес процессы запущены");
       });
    }

    addRowsSubMenuItem(iListId, obItem) {
        for (let sEvent of ["Grid::ready", "Grid::updated"]) {
            BX.addCustomEvent(sEvent, function (obMainGrid) {
                if (obMainGrid.containerId != `lists_list_elements_${iListId}`) {
                    return true;
                }

                for (let obRow of obMainGrid.getRows().getRows()) {
                    if (obRow.actionsButton === null) {
                        continue;
                    }
                    let iItemId = obRow.getId();
                    let obNewItem = {};
                    Object.assign(obNewItem, obItem);
                    obNewItem["href"] = obNewItem["href"]
                        .replace("#iListId#", iListId)
                        .replace("#iItemId#", iItemId);
                    obRow.getMenuItems().push(obNewItem);
                }
            });
        }
    }

    checklistsAndPrescriptions() {
        let LIST_ID = BX.message("LIST_ID_CHECKLIST_IMPROVEMENT_REGISTRY");
        const arIdToNamePropCodes = [
            "FIRST_RESPONSIBLE", "LAST_RESPONSIBLE"
        ];

        // Add task links NAME column
        BX.addCustomEvent("Grid::ready", (function (obMainGrid) {
            if (obMainGrid.containerId != `lists_list_elements_${LIST_ID}`) {
                return true;
            }
            let domNpvTypeColHead = obMainGrid.getColumnHeaderCellByName("NAME");
            if (domNpvTypeColHead == null) {
                return true;
            }
            domNpvTypeColHead.querySelector(".main-grid-head-title").textContent = "Задача";
            let iColIndex = domNpvTypeColHead.cellIndex;
            let arColumnCells = obMainGrid.getColumnByIndex(iColIndex);
            let arRowItemIdToLink = BX.message("LIST_ID_CHECKLIST_IMPROVEMENT_REGISTRY_arItemIdToTaskLink");
            arColumnCells.forEach((obCell, iInd) => {
                if ([0, 1].includes(iInd)) {
                    return true;
                }
                let domContent = obCell.querySelector(".main-grid-cell-content");
                if (domContent === null) {
                    return true;
                }
                let iRowItemId = obCell.parentElement.getAttribute("data-id");
                if (arRowItemIdToLink[iRowItemId] !== undefined) {
                    domContent.innerHTML = arRowItemIdToLink[iRowItemId];
                }
            });
        }).bind(this));

        // replace ids in column cells with it's values
        for (let sEvent of ["Grid::ready", "Grid::updated"]) {
            BX.addCustomEvent(sEvent, (function (obMainGrid) {
                if (obMainGrid.containerId != `lists_list_elements_${LIST_ID}`) {
                    return true;
                }
                for (let sPropCode of arIdToNamePropCodes) {
                    let iColIndex = this.getColumnIndexByPropertyAndListCodes(obMainGrid, "CHECKLIST_IMPROVEMENT_REGISTRY", sPropCode);
                    let obPropIdToName = this.getSelectPropIdToName("CHECKLIST_IMPROVEMENT_REGISTRY", sPropCode);
                    if (iColIndex <= 0) {
                        continue;
                    }
                    let arColumnCells = obMainGrid.getColumnByIndex(iColIndex);
                    arColumnCells.forEach((obCell, iInd) => {
                        if ([0, 1].includes(iInd)) {
                            return true;
                        }
                        let domContent = obCell.querySelector(".main-grid-cell-content");
                        if (domContent === null) {
                            return true;
                        }
                        let iId = +domContent.innerHTML;
                        if (iId <= 0) {
                            return true;
                        }
                        if (obPropIdToName[iId] !== undefined) {
                            domContent.innerHTML = obPropIdToName[iId];
                        }
                    });
                }
            }).bind(this));
        }

        // shortening well name
        for (let sEvent of ["Grid::ready", "Grid::updated"]) {
            BX.addCustomEvent(sEvent, (function (obMainGrid) {
                if (obMainGrid.containerId != `lists_list_elements_${LIST_ID}`) {
                    return true;
                }
                let iColIndex = this.getColumnIndexByPropertyAndListCodes(obMainGrid, "CHECKLIST_IMPROVEMENT_REGISTRY", "WELL_NAME");
                if (iColIndex <= 0) {
                    return true;
                }
                let arColumnCells = obMainGrid.getColumnByIndex(iColIndex);
                arColumnCells.forEach((obCell, iInd) => {
                    if ([0, 1].includes(iInd)) {
                        return true;
                    }
                    let domContent = obCell.querySelector(".main-grid-cell-content");
                    if (domContent === null) {
                        return true;
                    }
                    let sContent = domContent.textContent;
                    let arParts = sContent.split(" ");
                    if (arParts.length > 1) {
                        domContent.textContent = arParts[0];
                    }
                });
            }).bind(this));
        }
    }

    // List: Извлеченные уроки
    learnedLessons() {
        const iLearnedLessonsListId = BX.message("LIST_ID_LEARNED_LESSONS");
        const iKnowledgeBaseListId = BX.message("LIST_ID_KNOWLEDGE_BASE");
        const bCanAddKnowledgeBaseLesson = BX.message("LIST_ID_KNOWLEDGE_BASE");
        const arHideColumnTitles = [
            "Категория НПВ 1",
            "Категория НПВ 2",
            "Категория НПВ 3",
            "Категория НПВ 4",
            "Guid"
        ];
        const arIdToNamePropCodes = [
            "NPV_TYPE", "NPV_KIND", "NPV_CLASS", "FIRST_RESPONSIBLE", "LAST_RESPONSIBLE"
        ];

        // show well number instead of well name
        for (let sEvent of ["Grid::updated", "Grid::ready"]) {
            BX.addCustomEvent(sEvent, (function (obMainGrid) {
                if (obMainGrid.containerId != `lists_list_elements_${iLearnedLessonsListId}`) {
                    return true;
                }
                let iColIndex = this.getColumnIndexByPropertyAndListCodes(obMainGrid, "LEARNED_LESSONS", "WELL_NAME");
                if (iColIndex <= 0) {
                    return true;
                }
                let arColumnCells = obMainGrid.getColumnByIndex(iColIndex);
                arColumnCells.forEach((obCell, iInd) => {
                    if ([0, 1].includes(iInd)) {
                        return true;
                    }
                    let domContent = obCell.querySelector(".main-grid-cell-content");
                    if (domContent === null) {
                        return true;
                    }
                    let sContent = domContent.textContent;
                    let arParts = sContent.split(" ");
                    if (arParts.length > 1) {
                        domContent.textContent = arParts[0];
                    }
                });
            }).bind(this));
        }

        // shortening section name
        for (let sEvent of ["Grid::updated", "Grid::ready"]) {
            BX.addCustomEvent(sEvent, (function (obMainGrid) {
                if (obMainGrid.containerId != `lists_list_elements_${iLearnedLessonsListId}`) {
                    return true;
                }
                let iColIndex = this.getColumnIndexByPropertyAndListCodes(obMainGrid, "LEARNED_LESSONS", "SECTION");
                if (iColIndex <= 0) {
                    return true;
                }
                let arColumnCells = obMainGrid.getColumnByIndex(iColIndex);
                arColumnCells.forEach((obCell, iInd) => {
                    if ([0, 1].includes(iInd)) {
                        return true;
                    }
                    let domContent = obCell.querySelector(".main-grid-cell-content");
                    if (domContent === null) {
                        return true;
                    }
                    let sContent = domContent.textContent;
                    let arMatch = sContent.match(/^([^0-9]+)(.*)/);
                    if (arMatch !== null && arMatch.length == 3) {
                        domContent.textContent = arMatch[2];
                    }
                });
            }).bind(this));
        }

        // replace ids in column cells with it's values
        for (let sEvent of ["Grid::updated", "Grid::ready"]) {
            BX.addCustomEvent(sEvent, (function (obMainGrid) {
                if (obMainGrid.containerId != `lists_list_elements_${iLearnedLessonsListId}`) {
                    return true;
                }
                for (let sPropCode of arIdToNamePropCodes) {
                    let iColIndex = this.getColumnIndexByPropertyAndListCodes(obMainGrid, "LEARNED_LESSONS", sPropCode);
                    let obPropIdToName = this.getSelectPropIdToName("LEARNED_LESSONS", sPropCode);
                    if (iColIndex <= 0) {
                        continue;
                    }
                    let arColumnCells = obMainGrid.getColumnByIndex(iColIndex);
                    arColumnCells.forEach((obCell, iInd) => {
                        if ([0, 1].includes(iInd)) {
                            return true;
                        }
                        let domContent = obCell.querySelector(".main-grid-cell-content");
                        if (domContent === null) {
                            return true;
                        }
                        let iId = +domContent.innerHTML;
                        if (iId <= 0) {
                            return true;
                        }
                        if (obPropIdToName[iId] !== undefined) {
                            domContent.innerHTML = obPropIdToName[iId];
                        }
                    });
                }
            }).bind(this));
        }

        // show deviation value days
        for (let sEvent of ["Grid::updated", "Grid::ready"]) {
            BX.addCustomEvent(sEvent, (function (obMainGrid) {
                if (obMainGrid.containerId != `lists_list_elements_${iLearnedLessonsListId}`) {
                    return true;
                }
                let sPropCode = "DEVIATION_VALUE";
                let iColIndex = this.getColumnIndexByPropertyAndListCodes(obMainGrid, "LEARNED_LESSONS", sPropCode);
                if (iColIndex <= 0) {
                    return true;
                }
                let arColumnCells = obMainGrid.getColumnByIndex(iColIndex);
                arColumnCells.forEach((obCell, iInd) => {
                    if ([0, 1].includes(iInd)) {
                        return true;
                    }
                    let domContent = obCell.querySelector(".main-grid-cell-content");
                    if (domContent === null) {
                        return true;
                    }
                    let fNumber = +domContent.innerHTML;
                    if (isNaN(fNumber) || fNumber <= 0) {
                        return true;
                    }
                    let fDay = (new Number(fNumber / 24)).toFixed(2);
                    domContent.innerHTML = `${fNumber} (${fDay} суток)`;
                });
            }).bind(this));
        }

        // Add task links NAME column
        for (let sEvent of ["Grid::updated", "Grid::ready"]) {
            BX.addCustomEvent(sEvent, (function (obMainGrid) {
                if (obMainGrid.containerId != `lists_list_elements_${iLearnedLessonsListId}`) {
                    return true;
                }
                let domNpvTypeColHead = obMainGrid.getColumnHeaderCellByName("NAME");
                if (domNpvTypeColHead == null) {
                    return true;
                }
                domNpvTypeColHead.querySelector(".main-grid-head-title").textContent = "Задача";
                let iColIndex = domNpvTypeColHead.cellIndex;
                let arColumnCells = obMainGrid.getColumnByIndex(iColIndex);
                let arRowItemIdToLink = BX.message("LIST_ID_LEARNED_LESSONS_arItemIdToTaskLink");
                arColumnCells.forEach((obCell, iInd) => {
                    if ([0, 1].includes(iInd)) {
                        return true;
                    }
                    let domContent = obCell.querySelector(".main-grid-cell-content");
                    if (domContent === null) {
                        return true;
                    }
                    let iRowItemId = obCell.parentElement.getAttribute("data-id");
                    if (arRowItemIdToLink[iRowItemId] !== undefined) {
                        domContent.innerHTML = arRowItemIdToLink[iRowItemId];
                    }
                });
            }).bind(this));
        }

        // Add Knowledge Base links
        for (let sEvent of ["Grid::updated", "Grid::ready"]) {
            BX.addCustomEvent(sEvent, (function (obMainGrid) {
                if (obMainGrid.containerId != `lists_list_elements_${iLearnedLessonsListId}`) {
                    return true;
                }
                let sPropCode = "KNOWLEDGE_BASE_ID";
                let iColIndex = this.getColumnIndexByPropertyAndListCodes(obMainGrid, "LEARNED_LESSONS", sPropCode);
                if (iColIndex <= 0) {
                    return true;
                }
                let arColumnCells = obMainGrid.getColumnByIndex(iColIndex);
                arColumnCells.forEach((obCell, iInd) => {
                    if ([0, 1].includes(iInd)) {
                        return true;
                    }
                    let domContent = obCell.querySelector(".main-grid-cell-content");
                    if (domContent === null) {
                        return true;
                    }
                    let iKBItemId = +domContent.innerHTML;
                    if (iKBItemId <= 0) {
                        domContent.innerHTML = "Нет ссылки";
                        return true;
                    }
                    domContent.innerHTML = `<a href="/bizproc/processes/${iKnowledgeBaseListId}/element/0/${iKBItemId}/?list_section_id=">Запись в базе знаний #${iKBItemId}</a>`;
                });
            }).bind(this));
        }

        // hide columns in table and in table's settings window by column titles
        /* do not uncomment if no need for this, it destroys sorting
        BX.addCustomEvent("Grid::ready", function (obMainGrid) {
            if (obMainGrid.containerId != `lists_list_elements_${iLearnedLessonsListId}`) {
                return true;
            }
            obMainGrid.gridSettings.getItems().forEach(obSettingsWindowColumn => {
                if (arHideColumnTitles.includes(obSettingsWindowColumn.getTitle())) {
                    obSettingsWindowColumn.unselect();
                    obMainGrid.gridSettings.saveColumns(obMainGrid.gridSettings.getSelectedColumns(), null);
                    obSettingsWindowColumn.getNode().style.display = "none";
                }
            });
        });
        */

        // add custom actions to row menus
        BX.addCustomEvent("Grid::updated", function (obMainGrid) {
            if (obMainGrid.containerId != `lists_list_elements_${iLearnedLessonsListId}`) {
                return true;
            }

            for (let obRow of obMainGrid.getRows().getRows()) {
                if (obRow.actionsButton === null) {
                    continue;
                }
                if (BX.message("USER_CAN_ADD_LEARNED_LESSON_TO_KNOWLEDGE_BASE")) {
                    let iItemId = obRow.getId();
                    obRow.getMenuItems().push({
                        "ID": "addToKnowledgeBase",
                        "text": "Добавить запись в базу знаний",
                        "onclick": `javascript:BX.Webrover.obTemplate.getMainUiGrid().addLearnedLessonToKnowledgeBase(${iItemId});`
                    });
                }
            }
        });
    }

    addLearnedLessonToKnowledgeBase(iItemId) {
        fetch("/api/v1/lists/", {
            method: "POST",
            body: JSON.stringify({
                method: "addKnowledgeBaseRecordById",
                data: {
                    iLLRecordId: iItemId
                }
            })
        }).then(oResponse => oResponse.json())
          .then(oJson => {
              if (oJson.status == "error") {
                  alert(
                      oJson.error_data[0]
                          .replaceAll("<br>", "\n")
                          .replace("Ответственные", "Ответственный (уровень проект)")
                  );
              } else {
                  location.reload();
              }
          });

        return true;
    }

    getSelectPropIdToName(sListCode, sPropCode) {
        if (this.arPropArrays == undefined) {
            this.arPropArrays = {};
        }
        if (this.arPropArrays[sPropCode] == undefined) {
            this.arPropArrays[sPropCode] = [];
            let obNpvTypePropVal = BX.message(`LIST_ID_${sListCode}_VALUES_${sPropCode}`);
            if (typeof obNpvTypePropVal == "string") {
                obNpvTypePropVal = eval(BX.message(`LIST_ID_${sListCode}_VALUES_${sPropCode}`))
            }
            obNpvTypePropVal.forEach(obEl => {
                this.arPropArrays[sPropCode][obEl.VALUE] = obEl.NAME;
            });
        }
        return this.arPropArrays[sPropCode];
    }

    getColumnIndexByPropertyAndListCodes(obMainGrid, sListCode, sPropCode) {
        let iPropId = BX.message(`LIST_ID_${sListCode}_PROP_ID_${sPropCode}`);
        let domNpvTypeColHead = obMainGrid.getColumnHeaderCellByName(`PROPERTY_${iPropId}`);
        if (domNpvTypeColHead == null) {
            return -1;
        }
        return domNpvTypeColHead.cellIndex;
    }
}
